<template>
  <div
    class="lego-drop-holder lego-input multi-dropdown-wrap"
    :class="dropdownClass"
    ref="legoDropHolder"
  >
    <div class="lego-drop-holder__holder" @click="onClick">
      <lego-icon
        :icon-type="iconType"
        :icon="iconName"
        :size="20"
        v-lego-tooltip="{ value: $t('label.statisticalType'), moreAction: 'clickToHide' }"
      >
      </lego-icon>
      <div class="static-title" v-if="$slots.staticTitle">
        <slot name="staticTitle"></slot>
      </div>

      <div
        _comment="content 박스"
        class="lego-dropdown__items_box"
        :class="itemsClass"
        :style="[contentWidth, contentHeight, contentLeft]"
        v-show="isItemShowing > 0"
        v-click-outside="close"
      >
        <div class="dropdown-title">
          <span>{{ $t('label.statisticalType') }}</span>
          <lego-icon icon="close" :size="20" @click.stop="close" />
        </div>
        <div
          class="dropdown-box"
          :style="[statsValue.length > 0 ? { padding: '32px 0 0 0' } : { padding: '6px 0 0 0' }]"
        >
          <div v-if="statsValue.length === 0" style="color: #fc434e; padding-bottom: 2px">
            {{ $t('message.pleaseSelectOne') }}
          </div>
          <div class="dropdown-wrapper">
            <scpm-tag-dropdown
              ref="staticMethod"
              showOnlyKey
              isChangeTextShow
              :isStaticType="true"
              :items="statisticalTypes"
              v-model="statsValue"
              @tag-input="checkStatsItems"
              width="194px"
              select-all
              :selectAllText="$t('label.selectAll')"
            />
            <div class="dropdown-btn">
              <lego-button medium @click.stop="doAction('reset')">{{
                $t('button.reset')
              }}</lego-button>
              <lego-button medium main @click.stop="doAction('confirm')">{{
                $t('button.confirm')
              }}</lego-button>
            </div>
          </div>
        </div>
        <div v-if="emptyStatisticsType" class="message">{{ $t('message.selectStatistics') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import legoValidatorMixin from '../../../lego-component/mixins/legoValidator/legoValidatorMixin.vue';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';
import { toRaw } from 'vue';

const UNSELECT_DROPDOWN_TITLE = 'Select';
const DEFAULT_ITEM_TEXT = 'text';
const DEFAULT_ITEM_VALUE = 'value';

export default {
  name: 'lego-multi-date-picker-extend',
  mixins: [legoValidatorMixin],
  inject: {
    legoInput: { from: 'legoInput', default: () => undefined }
  },
  props: {
    items: { type: Array, default: () => [] },
    modelValue: { type: [String] },
    placeholder: { type: String },
    width: { type: [Number, String] /*px*/ },
    height: { type: [Number, String] /*px*/ },
    itemText: { type: [String, Function], default: DEFAULT_ITEM_TEXT },
    itemValue: { type: String, default: DEFAULT_ITEM_VALUE },
    inputValue: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    successMessage: { type: String, default: undefined },
    messageStyle: {
      type: String,
      validator: function (value) {
        return ['heavy', 'light'].indexOf(value) !== -1;
      },
      default: 'heavy'
    },
    medium: { type: Boolean, default: false },
    md: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    sm: { type: Boolean, default: false },
    up: { type: Boolean, default: false },
    rowId: { type: [Number, String] },
    statsTypes: { type: Array, required: false },
    isSummary: { type: Boolean, default: false },
    index: { type: Number, default: 0 }
  },
  data() {
    return {
      unselectMessage: '',
      value1: '',
      value2: 'MAX',
      default: {
        size: 'medium',
        placeholder: UNSELECT_DROPDOWN_TITLE
      },

      isItemShowing: 0,
      filteredItemList: [],
      focusedItemIndex: -1,
      focusedChildItemIndex: -1,
      focusedDepthIndex: 0,
      isFocused: false,
      resultValue: '', // v-model
      resultText: '', // label
      statsValue: [],
      previousStatsValue: [],
      dropdownData: [
        { txt: 'Raws', iconType: 'line', iconName: 'bar_chart2' },
        { txt: 'Statistics', iconType: 'line', iconName: 'bar_chart' }
      ],
      iconType: 'line',
      iconName: 'bar_chart',
      emptyStatisticsType: false
    };
  },
  mounted() {
    legoEventBus.$on('click-outside', () => this.close());
  },

  beforeMount() {
    legoEventBus.$off('click-outside', () => this.close());
  },
  computed: {
    validateTarget() {
      return this.modelValue;
    },

    statisticalTypes() {
      return [
        {
          value: this.$t('label.max'),
          key: 'MAX',
          tagKey: this.$t('label.max'),
          tagValue: 'MAX',
          idx: 0
        },
        {
          value: this.$t('label.min'),
          key: 'MIN',
          tagKey: this.$t('label.min'),
          tagValue: 'MIN',
          idx: 1
        },
        {
          value: this.$t('label.avg'),
          key: 'AVG',
          tagKey: this.$t('label.avg'),
          tagValue: 'AVG',
          idx: 2
        },
        {
          value: this.$t('label.sum'),
          key: 'SUM',
          tagKey: this.$t('label.sum'),
          tagValue: 'SUM',
          idx: 3
        }
      ];
    },

    $_size() {
      if (this.medium || this.md) {
        return 'medium';
      }
      if (this.small || this.sm) {
        return 'small';
      }
      if (this.legoInput) {
        return this.legoInput.size;
      }
      return this.default.size;
    },
    itemsMap() {
      let map = new Map(),
        me = this;
      buildMap(this.items);
      return map;
      function buildMap(arr) {
        arr.forEach((item) => {
          let key;
          if (me.itemValue === 'object') {
            key =
              me.inputValue && item[me.inputValue] !== undefined
                ? item[me.inputValue]
                : item[DEFAULT_ITEM_VALUE];
          } else {
            key = me.getValue(item);
          }
          map.set(key, item);
          if (item.childItems) {
            buildMap(item.childItems);
          }
        });
      }
    },
    selItem() {
      return this.itemsMap.get(this.modelValue);
    },
    hasChildItems() {
      let flag = false;
      this.items.forEach((item) => {
        flag = flag || !!item.childItems;
      });
      return flag;
    },
    itemsClass() {
      let clazz = [];
      if (this.hasChildItems) clazz.push('lego-dropdown__items--has-child-items');
      return clazz;
    },
    dropdownWidth() {
      if (!this.width) {
        return null;
      }
      let _width = this.width;
      _width = '50';
      return { width: this.getNumber(_width) + 'px' };
    },
    dropdownHeight() {
      if (!this.height) {
        return null;
      }
      return { height: this.getNumber(this.height) + 'px' };
    },
    dropdownClass() {
      return {
        'lego-dropdown--disabled': this.disabled,
        'lego-dropdown--medium': this.$_size === 'medium',
        'lego-dropdown--small': this.$_size === 'small',
        'lego-dropdown--up': this.up,
        'lego-validator--error': this.hasError === true,
        'lego-validator--valid': this.showValid && this.hasError === false,
        'lego-validator--shake': this.shake,
        'dropdown-with-label': this.isSummary
      };
    },
    contentWidth() {
      return { width: '800px' };
    },
    contentLeft() {
      if (!this.isSummary || this.index > 0) {
        return '';
      }
      return { left: '0' };
    },
    contentHeight() {
      return { height: '500px' };
    },
    caretStyle() {
      let style = {};
      if ((this.isItemShowing && !this.up) || (!this.isItemShowing && this.up)) {
        style['transform'] = 'rotate(-180deg)';
      }
      style['transition-duration'] = '0.3s';
      return style;
    },
    dropdownTitleStyle() {
      if (!this.height) return {};
      let height = this.getNumber(this.height) - 2; /* minus 2px for border */
      return { height: height + 'px', 'line-height': height + 'px' };
    }
  },
  watch: {
    items() {
      if (this.items.findIndex((i) => i.value == this.value1) < 0)
        this.value1 = this.getDefaultValue1();
    },
    validateTarget() {
      this.validateOnEvent(); // whenever checked value changes, execute validate() if lazy is false
    },
    successMessage: {
      immediate: true,
      handler(val) {
        this.showValid = !!val;
      }
    },
    isItemShowing() {
      if (this.isItemShowing) {
        this.focusedItemIndex = -1;
        this.focusedDepthIndex = 0;
        this.focusedChildItemIndex = -1;
      }
    },

    focusedDepthIndex() {
      if (this.focusedDepthIndex === 1) {
        this.focusedChildItemIndex = 0;
      } else {
        this.focusedChildItemIndex = -1;
      }
    },
    isFocused() {
      if (this.isFocused) {
        this.isItemShowing = true;
      }
    }
  },
  created() {
    this.value1 = this.getDefaultValue1();
    this.statsValue = this.statsTypes
      ? this.getStatisticalTypeByValues(this.statsTypes)
      : this.getDefaultStatistical();
    this.previousStatsValue = this.statsValue;
  },
  methods: {
    getDefaultStatistical() {
      return [this.statisticalTypes[0]];
    },

    getDefaultValue1() {
      if (this.items.length > 0 && this.items[0].value) return this.items[0].value;
      return '';
    },

    getStatisticalTypeByValues(values) {
      if (!values.length) return this.getDefaultStatistical();

      return this.statisticalTypes.filter(function (item) {
        return values.includes(item.key);
      });
    },

    getText(item) {
      //console.log('# getText : ', item);
      return 'MAG';
    },
    getValue(item) {
      //console.log('# getValue : ', item);
      return 'COC5';
    },
    getNumber(str) {
      //console.log('# getNumber : ', str);
      let v = str;
      if (isNaN(v)) {
        v = v.replace(/[^0-9]/g, '');
      }
      return parseInt(v);
    },
    toggleItem() {
      this.isItemShowing += 2;
    },
    toggleItemOuter() {
      if (this.isItemShowing > 0) {
        this.isItemShowing--;
      }
      if (this.isItemShowing == 0) {
        this.emptyStatisticsType = false;
      }
    },
    close() {
      this.statsValue = this.previousStatsValue;
      this.toggleItemOuter();
    },
    isSelectedItem(item) {
      //console.log('# isSelectedItem : ', item);
      return this.selItem === item;
    },
    onInput(input) {
      //console.log('# onInput : ', input);
      this.onFilter(input.target.value);
    },
    onFilter(value) {
      //console.log('# onFilter : ', value);
      if (value) {
        this.filteredItemList = this.items.filter((item) => {
          return item[this.itemText].toLowerCase().indexOf(value.toLowerCase().trim()) > -1;
        });
      } else {
        this.filteredItemList = this.items.slice();
      }
    },
    onKeydown(event) {
      let keyCode = event.keyCode;
      //console.log('# onKeydown : keyCode', keyCode);
    },
    focusScroll(target) {
      //console.log('# focusScroll : ', target);
      if (!target || !target.offsetParent) {
        return;
      }
      let parent = target.offsetParent;
      parent.scrollTop = target.offsetTop - parent.offsetHeight + parent.offsetHeight / 2;
    },
    /********************************
     * 함수 추가함
     *******************************/
    // 액션 모음
    doAction(cmd, parms) {
      this.$refs.staticMethod && this.$refs.staticMethod.toggleItemOuter();
      //this.$toast.open('... doAction $$$$$ cmd: ' + cmd + ', parms: ' + JSON.stringify(parms, null, '  '));
      //console.log('★ doAction ', cmd, JSON.stringify(parms, null, '  '));

      if (cmd === 'reset') {
        this.statsValue = this.getDefaultStatistical();

        if (this.statsTypes.length) {
          this.statsTypes.splice(0, this.statsTypes.length);
        }

        this.previousStatsValue = this.statsValue;
        let result = {
          rowId: this.rowId,
          value1: null,
          value2: this.statsValue.map((item) => item.key).join(',')
        };
        this.$emit('click-reset', result);
        this.toggleItemOuter();
      } else if (cmd === 'confirm') {
        this.iconName = this.dropdownData[1].iconName;
        if (this.statsValue.length === 0) {
          return;
        }
        let result = {
          rowId: this.rowId,
          value1: '5',
          value2: this.statsValue.map((item) => item.key).join(',')
        };
        this.$emit('confirm', result);
        this.toggleItemOuter();
        this.previousStatsValue = this.statsValue;
      } else {
        alert('doAction 잘못된 cmd [' + cmd + ']');
      }
    },

    // 결과값 반환
    getData(cmd) {
      if (cmd == 'xxx') {
      } else {
        alert('getData 잘못된 cmd [' + cmd + ']');
      }
    },

    checkStatsItems(item) {
      // this.statsValue = toRaw(item);
      this.statsValue = [...this.statsValue, ...item]
    },
    onClick(item) {
      if (item.txt == this.dropdownData[0].txt) {
        this.iconName = this.dropdownData[0].iconName;
        let result = { rowId: this.rowId, value1: '', value2: '' };
        this.$emit('confirm', result);
      } else {
        if (this.isItemShowing > 0) {
          return;
        }
        this.toggleItem();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown-with-label {
  padding: 10px 16px;
  height: auto !important;
  width: 100% !important;
}
.static-title {
  font-size: 14px;
  line-height: 16px;
  margin-left: 12px;
  vertical-align: middle;
  width: 100% !important;
}
.lego-drop-holder {
  &__holder {
    display: flex;
  }
}
.multi-dropdown-wrap {
  .lego-dropdown__items_box {
    position: absolute;
    top: 34px;
    right: 0;
    width: 428px !important;
    height: 152px !important;
    padding: 20px 14px 30px;
    border: solid 1px var(--blue-with-a-hint-of-purple);
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
    overflow-y: visible;
    background: #fff;
    z-index: 1;
  }

  .dropdown-title {
    padding: 0 0 8px;
    line-height: normal;
    font-family: $lego__font-family;
    font-size: 16px;
    font-weight: 700;
    color: #000;
    border-bottom: solid 1px var(--silver);

    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .dropdown-box {
    .dropdown-wrapper {
      display: flex;
      align-items: center;
      .dropdown-btn {
        display: flex;
        align-items: center;
      }
    }
    .lego-dropdown {
      width: 180px;
      margin-right: 5px;

      & + .leg-button {
        margin-left: 15px;
      }
    }

    .lego-button {
      margin-left: 5px;
    }
  }
}

.lego-dropdown__title {
  padding: 0 10px 0 0 !important;
  border: 0 !important;
}
.lego-dropdown__title :deep .lego-button--border {
  border-color: #fff !important;
}
.lego-dropdown--medium .lego-dropdown__title-icon {
  margin-left: 0 !important;
}
.message {
  margin-left: 10px;
  color: #fc434e;
  font-size: 12px;
}
</style>
